export const FETCH_USER_SUBSCRIPTIONS = 'components/subscriptions/FETCH_USER_SUBSCRIPTIONS';
export const SET_USER_FETCH_STATE = 'components/subscriptions/SET_USER_FETCH_STATE';
export const SET_USER_SUBSCRIPTIONS = 'components/subscriptions/SET_USER_SUBSCRIPTIONS';
export const SET_USER_ERROR = 'components/subscriptions/SET_USER_ERROR';
export const UPDATE_USER_SUBSCRIPTIONS = 'components/subscriptions/UPDATE_USER_SUBSCRIPTIONS';
